interface PriceEstimationProps {
  priceCents: number;
  isCommission: boolean;
  bcFeeCents: number;
  stripeFeeCents: number;
  netOrgaCents: number;
}

export function PriceEstimation({
  priceCents,
  isCommission,
  bcFeeCents,
  stripeFeeCents,
  netOrgaCents,
}: PriceEstimationProps) {
  if (priceCents <= 0) return null;

  return (
    <div className='col-span-3 rounded-xl border border-slate-200 bg-slate-50 p-4'>
      <p className='mb-3 text-sm font-bold text-slate-700'>💰 Estimation par inscription</p>
      <div className='space-y-1 text-sm text-slate-600'>
        <div className='flex justify-between'>
          <span>Prix par &eacute;quipe</span>
          <span className='font-semibold'>{(priceCents / 100).toFixed(2)} €</span>
        </div>
        {isCommission && (
          <div className='flex justify-between text-amber-600'>
            <span>Commission BoulesConnect (2 % + 0,30 €, min 0,75 €)</span>
            <span className='font-semibold'>− {(bcFeeCents / 100).toFixed(2)} €</span>
          </div>
        )}
        <div className='flex justify-between text-slate-400'>
          <span>Frais Stripe (estimation*)</span>
          <span>− {(stripeFeeCents / 100).toFixed(2)} €</span>
        </div>
        <hr className='my-2 border-slate-200' />
        <div className='flex justify-between font-bold text-emerald-600'>
          <span>Vous encaissez (estimation)</span>
          <span>{(netOrgaCents / 100).toFixed(2)} €</span>
        </div>
      </div>
      <p className='mt-2 text-xs text-slate-400'>
        *Frais Stripe indicatifs (1.5% + 0.25€ cartes FR). Montants r&eacute;els sur{' '}
        <a href='https://stripe.com/pricing' target='_blank' rel='noopener' className='hover:text-blue-600'>
          https://stripe.com/pricing
        </a>
      </p>
    </div>
  );
}
